import { render, staticRenderFns } from "./ChartByMetricsWidgetComponent.vue?vue&type=template&id=0b12cf02&"
import script from "./ChartByMetricsWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./ChartByMetricsWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports